export const useSxStyles = () => {
  return {
    tableContainer: {
      padding: 0,
    },
  };
};
